import {Box} from "@mui/material"
import {useLocation} from "react-router-dom"

import {Header, Footer} from "./components";

interface IMainProps {
    children?: any
}

export const MainLayout = (props: IMainProps) => {
    const {children} = props
    const location = useLocation();

    const noLayoutRoutes = ["/", "/terms-of-use", "/professional-information", "/practice-information", "/not-found"];

    const hideLayout = noLayoutRoutes.includes(location.pathname);

    return (
        <Box display="flex" flexDirection="column" minHeight={"100vh"}>
            {!hideLayout && <Header/>}
            <main style={{ flexGrow: 1, marginTop: hideLayout ? 0 : 60 }}>
                {children}
            </main>
            {!hideLayout && <Footer/>}
        </Box>
    )
}